export const AppConfig = {
    env: process.env.WEB_APP_ENV,
    wsUrl: process.env.WEB_API_WS,
    appDomain: process.env.WEB_APP_DOMAIN_URL,
    mediaUrl: process.env.MEDIA_URL,
    googleAPIKey:  process.env.GOOGLE_API_KEY,
    streamUrl: process.env.STREAM_URL,
    sandboxLoginId: process.env.SANDBOX_LOGIN_ID,
}